import { useState } from 'react'
import Spinner from '../input/Spinner'
import { clearBoard } from '../../miro'
import {
  CopyOutlined,
  ExpandAltOutlined,
  LogoutOutlined,
  RedoOutlined,
  VerticalAlignBottomOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Menu } from 'antd'
import { renderTimelineCanvas } from 'src/util/canvas/board2Canvas'
import { useBoard } from 'src/hooks/useBoard'
import { useAppCards } from 'src/query/tableKeeper'
import { taskCtrlLink } from 'src/util/const/util'
import useProjectId from 'src/hooks/useProjectId'

type MenuItem = Required<MenuProps>['items'][number]

const UserMenu = () => {
  const [resetInProcess, setResetInProcess] = useState(false)
  const projectId = useProjectId()

  const onLogout = async () => {
    localStorage.clear()
    window.location.reload()
  }

  const reset = async () => {
    if (resetInProcess) return
    setResetInProcess(true)
    await clearBoard()
    setResetInProcess(false)
  }

  const {
    query: { data: timeline },
  } = useBoard()

  const { data: appCardsData } = useAppCards()

  const previewTimeline = () => {
    if (!timeline) return
    renderTimelineCanvas(timeline, appCardsData ?? [])
  }

  const openMigratePage = () => {
    miro.board.ui.openModal({
      url: '/migrateProject',
      fullscreen: true,
    })
  }

  const onClick = (e: { key: string }) => {
    switch (e.key) {
      case 'reset':
        reset()
        break
      case 'logout':
        onLogout()
        break
      case 'export':
        previewTimeline()
        break
      case 'migrate':
        openMigratePage()
        break
      default:
        break
    }
  }

  const items: MenuItem[] = [
    {
      label: 'Reset Board',
      key: 'reset',
      icon: <RedoOutlined />,
      disabled: resetInProcess,
    },
    {
      label: 'Export Timeline Snapshot',
      key: 'export',
      icon: <VerticalAlignBottomOutlined />,
      disabled: !timeline,
    },
    {
      key: 'open',
      icon: <ExpandAltOutlined />,
      label: (
        <a
          href={taskCtrlLink(
            `/delivery/timelines/by_discipline?project=${projectId}`,
          )}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open TaskCtrl
        </a>
      ),
    },
    {
      label: 'Copy Project Template',
      key: 'migrate',
      icon: <CopyOutlined />,
    },
    {
      label: 'Logout',
      key: 'logout',
      danger: true,
      icon: <LogoutOutlined />,
    },
  ]

  return (
    <div className="flex flex-col gap-1">
      <Menu
        selectedKeys={[]}
        onClick={onClick}
        items={items}
        mode="inline"
        inlineIndent={4}
      />
      <div className="flex bg-transparent w-full">
        {resetInProcess && <Spinner />}
      </div>
    </div>
  )
}

export default UserMenu
